<template>
  <div class="profileView responsive-height">
    <v-container class="main-container">
      <v-row>
        <ProfileCard />
      </v-row>

      <v-row>
        <InfoCard :isFirstCard="true" />
        <InfoCard :isFirstCard="false" />
      </v-row>

      <v-row dense>
        <v-col lg="12" md="12" sm="12" cols="12">
          <agreement-card></agreement-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-card elevation="0" class="all-trade-tab rounded-0 deposit-tab">
            <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
              <v-tab v-if="$canRoute('trading-account-reg-tab') > 0"> Trading Accounts </v-tab>
              <v-tab v-if="$canRoute('deposit-reg-tab') > 0"> Deposit </v-tab>
              <v-tab v-if="$canRoute('withdraw-reg-tab') > 0"> Withdraw </v-tab>
              <v-tab v-if="$canRoute('internal-transfer-reg-tab') > 0"> Internal Trx. </v-tab>
              <v-tab v-if="$canRoute('credit-in-out-reg-tab') > 0"> Credit in/out </v-tab>
              <v-tab v-if="$canRoute('bank-crypto-reg-tab') > 0"> Bank & Crypto Acc. </v-tab>
              <v-tab v-if="$canRoute('documents-reg-tab') > 0"> Documents </v-tab>
              <v-tab v-if="$canRoute('demo-acc-reg-tab') > 0"> Demo Accounts </v-tab>
              <v-tab v-if="$canRoute('live-trade-reg-tab') > 0"><v-icon class="blink" color="#FF567F"> mdi-circle-small</v-icon> Live Trades</v-tab>
              <v-tab v-if="$canRoute('closed-trades-reg-tab') > 0"> Closed Trades </v-tab>
              <v-tab v-if="$canRoute('leverage-reg-tab') > 0"> Leverage </v-tab>
              <v-tab v-if="$canRoute('acc-limitations-reg-tab') > 0"> Acc. Limitations </v-tab>
              <v-tab-item v-if="$canRoute('trading-account-reg-tab') > 0">
                <TradingAccountTab></TradingAccountTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('deposit-reg-tab') > 0">
                <DepositItemTab></DepositItemTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('withdraw-reg-tab') > 0">
                <WithdrawItemTab></WithdrawItemTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('internal-transfer-reg-tab') > 0">
                <InternalTransferTab></InternalTransferTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('credit-in-out-reg-tab') > 0">
                <CreditInOutTab></CreditInOutTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('bank-crypto-reg-tab') > 0">
                <BankCryptoAccountTab></BankCryptoAccountTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('documents-reg-tab') > 0">
                <DocumentItemTab></DocumentItemTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('demo-acc-reg-tab') > 0">
                <DemoAccountsTab></DemoAccountsTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('live-trade-reg-tab') > 0">
                <LiveTradeTab></LiveTradeTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('closed-trades-reg-tab') > 0">
                <ClosedTradeTab></ClosedTradeTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('leverage-reg-tab') > 0">
                <LeverageDataTableTab></LeverageDataTableTab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('acc-limitations-reg-tab') > 0">
                <AccountLimitationsDataTableTab></AccountLimitationsDataTableTab>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  REGISTERUSERDETAILS__ACTIONS,
} from "@/store/action-types";
import AgreementCard from "@/components/RegisteredUser/AgreementCard.vue";
import AccountLimitationsDataTableTab from "@/components/RegisteredUser/AccountLimitationsDataTableTab.vue";
import BankCryptoAccountTab from "@/components/RegisteredUser/BankCryptoAccountTab.vue";
import ClosedTradeTab from "@/components/RegisteredUser/ClosedTradeTab.vue";
import CreditInOutTab from "@/components/RegisteredUser/CreditInOutTab.vue";
import DemoAccountsTab from '@/components/RegisteredUser/DemoAccountsTab.vue';
import DepositItemTab from "@/components/RegisteredUser/DepositItemTab.vue";
import DocumentItemTab from '@/components/RegisteredUser/DocumentItemTab.vue';
import InactiveAccountTab from '@/components/RegisteredUser/InactiveAccountTab.vue';
import InfoCard from "@/components/RegisteredUser/InfoCard.vue";
import InternalTransferTab from "@/components/RegisteredUser/InternalTransferTab.vue";
import LeverageDataTableTab from "@/components/RegisteredUser/LeverageDataTableTab.vue";
import LowBalanceAccountsTab from '@/components/RegisteredUser/LowBalanceAccountTab.vue';
import LiveTradeTab from "@/components/RegisteredUser/LiveTradeTab.vue";
import ProfileCard from "@/components/RegisteredUser/ProfileCard.vue";
import TradingAccountTab from '@/components/RegisteredUser/TradingAccountTab.vue';
import WithdrawItemTab from "@/components/RegisteredUser/WithdrawItemTab.vue";
export default {
  components: {
    ProfileCard,
    InfoCard,
    DepositItemTab,
    WithdrawItemTab,
    InternalTransferTab,
    CreditInOutTab,
    BankCryptoAccountTab,
    DocumentItemTab,
    TradingAccountTab,
    LiveTradeTab,
    ClosedTradeTab,
    LeverageDataTableTab,
    AccountLimitationsDataTableTab,
    DemoAccountsTab,
    InactiveAccountTab,
    LowBalanceAccountsTab,
    AgreementCard
  },
  data() {
    return {
      openParentTree: false,
      dropdownItems: [
        { text: "Add New Live Account", link: "/" },
        { text: "Add New Demo Account", link: "/" },
        { text: "Change Account Type", link: "/" },
        { text: "Deposit Funds", link: "/" },
        { text: "Withdraw Funds", link: "/" },
        { text: "Internal Transfer", link: "/" },
        { text: "Credit In / Out", link: "/" },
        { text: "Change Password", link: "/" },
        { text: "Change MT5 Password", link: "/" },
        { text: "Change Leverage", link: "/" },
        { text: "Block This User", link: "/" },
        { text: "Unblock This User", link: "/" },
      ],
    };
  },
  computed: {
    ...mapState("reguserdetails", ["parentdescendants"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.ACCOUNTDESCENDANTS]),
  },
  async mounted() {
    await this[REGISTERUSERDETAILS__ACTIONS.ACCOUNTDESCENDANTS](userId)
  }
};
</script>

<style lang="scss">
.deposit-tab {
  .v-tabs {
    .v-item-group {
      &.theme--light {
        ul {
          li {
            button {
              span {
                &.v-btn__content {
                  color: #fff;
                }
              }
            }
          }
        }
      }

      ul {
        gap: 10px;

        li {
          button {
            margin-top: 5px;

            &.custom-hight {
              height: 39px;

              span {
                margin-bottom: 0;
              }
            }

            span {
              &.v-btn__content {
                color: #131c29;
                font-size: 12px;

                i {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .crypto-bank-card {
        &.theme--light {
          p {
            color: #162334;

            span {
              color: #162334;
              font-weight: 300;
            }
          }
        }

        h3 {
          display: flex;
          align-items: center;
          margin-left: 30px;

          .v-image {
            max-width: 28px;
            margin: 20px 0;
          }

          span {
            margin-left: 1rem;
            margin-top: 4px;
          }
        }

        ul {
          display: block;
          margin-left: 30px;
          margin-top: 10px;
          margin-bottom: 30px;

          li {
            margin-bottom: 1rem;

            p {
              color: #fff;
              font-size: 13px;
              font-weight: 500;
              line-height: 20px;
              margin: 0;

              span {
                color: #8ba0ba;
                margin-left: 10px;
              }

              button {
                color: #8ba0ba;
                cursor: pointer;
                margin: 0 0 0 1rem;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
